module.exports = _.negate;